<div class="comp-header">
  <h1 class="h3">Oprettelse af organisation: Trin for trin</h1>
</div>
<div class="comp-main">
  <mat-vertical-stepper #stepper [linear]="true" (selectionChange)="onStepChange($event)">
    <mat-step [label]="step1Label()" [editable]="!organization()">
      <adm-step1-organization (refreshStepEvent)="refreshStep1($event)"></adm-step1-organization>
    </mat-step>
    <mat-step [label]="step2Label()" [editable]="organization()">
      @if (organization()) {
        <adm-step2-departments
          [departments]="departments()"
          [newDepartmentId]="newDepartmentId()"
          (editDepartmentIdEvent)="loadDepartmentForm($event)"
          (updateDepartments)="updateDepartments()"></adm-step2-departments>
        <adm-step2-department-form
          (refreshStep2Event)="refreshStep2($event)"
          (nextStep)="nextStep()"
          (updateDepartments)="updateDepartments()"
          [organization]="organization()!"
          [editDepartmentId]="editDepartmentId()"></adm-step2-department-form>
      }
    </mat-step>
    <mat-step [label]="step3Label">
      @if (organization()) {
        <adm-step3-access-groups
          [organization]="organization()!"
          [priceRegulationsEnabled]="priceRegulationsFeatureEnabled()"
          (skipStep)="nextStep()"></adm-step3-access-groups>
      }
    </mat-step>
    @if (priceRegulationsFeatureEnabled()) {
      <mat-step [label]="step4Label">
        @if (organization() !== null) {
          <adm-step4-price-regulations [organization]="organization()!" (skipStep)="nextStep()"></adm-step4-price-regulations>
        }
      </mat-step>
    }
    <mat-step [label]="step5Label">
      @if (organization() !== null) {
        <adm-step5-modules [organization]="organization()!" (skipStep)="nextStep()"></adm-step5-modules>
      }
    </mat-step>
    <mat-step [label]="step6Label">
      @if (organization() !== null) {
        <adm-step6-users [organization]="organization()!" [departments]="departments()" (skipStep)="nextStep()"></adm-step6-users>
      }
    </mat-step>
  </mat-vertical-stepper>
</div>
